import type { FC } from "react";
import { LegalLinks } from "@huub-web/auth";

import { legalContent } from "../../config/legal";

import { footerStyle } from "./LegalFooter.css";

/**
 * Footer with this deployment's legal documents and statutory notice.
 * Reads the deployment config directly, since `AuthConfigProvider` only
 * wraps the auth pages. Renders nothing for deployments without legal
 * content.
 */
export const LegalFooter: FC = () => {
  const { links, notice } = legalContent;

  if (links.length === 0 && !notice) return null;

  return (
    <footer className={footerStyle}>
      <LegalLinks links={links} notice={notice} />
    </footer>
  );
};
